import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import {
  AppState,
  CategoryFilterOption,
  CategoryFilterState,
  MainCategoryFilterState,
  SubcategoryOptionsMap,
} from '@immosky/types';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
  resetCategoryFilter,
  selectAppliedSubcategoryCount,
  selectCategoryFilterState,
  setMainCategoryFilter,
  setSubcategoryFilter,
} from '@immosky/object-search-filter';

@Component({
  selector: 'app-category-filter-dropdown',
  templateUrl: './category-filter-dropdown.component.html',
  styleUrls: ['./category-filter-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryFilterDropdownComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  appliedCategoryFilter!: MainCategoryFilterState;
  appliedSubcategoryCount = 0;

  isCurrentCategoryFilterActive = false;
  currentCategoryFilter!: CategoryFilterOption;
  currentSubcategoryFilter!: SubcategoryOptionsMap;

  displaySubcategory = false;

  get showSubcategoryFilter(): boolean {
    return (
      this.displaySubcategory && this.currentCategoryFilter.value !== 'all'
    );
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.subscriptions.push(
      this.store
        .pipe(select(selectCategoryFilterState))
        .subscribe((filterState: CategoryFilterState) => {
          this.appliedCategoryFilter = filterState.main;
          this.currentCategoryFilter = filterState.main.filter;
          this.isCurrentCategoryFilterActive = filterState.main.isActive;
          this.displaySubcategory = filterState.sub.isDisplayed;

          this.cdRef.markForCheck();
        })
    );

    this.subscriptions.push(
      this.store
        .pipe(select(selectAppliedSubcategoryCount))
        .subscribe((count: number) => {
          this.appliedSubcategoryCount = count;
          this.cdRef.markForCheck();
        })
    );
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  selectCategory(filter: CategoryFilterOption) {
    this.currentCategoryFilter = filter;
  }

  selectSubcategories(filter: SubcategoryOptionsMap) {
    this.currentSubcategoryFilter = filter;
  }

  applyChanges() {
    if (this.currentCategoryFilter) {
      this.store.dispatch(
        setMainCategoryFilter({
          filter: this.currentCategoryFilter,
        })
      );

      if (this.currentSubcategoryFilter) {
        this.store.dispatch(
          setSubcategoryFilter({
            filter: this.currentSubcategoryFilter,
          })
        );
      }
    }
  }

  reset() {
    this.store.dispatch(resetCategoryFilter());
  }
}
